module.exports = __webpack_public_path__ + "img/1716866738610-keripik bawang tsurayya.jpg.b2658f72.webp";